import React from "react"
import { useState, useMemo, useContext } from 'react'
import { iconMap } from '../modules/onboarding-form/components/onboarding-wizard/iconImports'
import { OnboardingContext } from '@/context/OnboardingContext'

/**
 * Custom hook to manage icon states (default, hover, active)
 * @param {string} style - The style name (e.g., 'modern', 'classic', 'bold')
 * @param {number} index - The icon index (0-3)
 * @returns {Object} Object containing current icon source and state setters
 */
export const useIconStates = (style, index) => {
  const [isHovered, setIsHovered] = useState(false)
  const { layout } = useContext(OnboardingContext)

  const currentIconSrc = useMemo(() => {
    const styleIcons = iconMap[style.toLowerCase()]
    if (!styleIcons || !styleIcons[index]) {
      console.warn(`Icon not found for style: ${style}, index: ${index}`)
      return null
    }

    const iconStates = styleIcons[index]
    
    // Active state is based on whether this index matches the selected layout
    const isActive = layout === index
    // if (isActive) return iconStates.active
    // if (isHovered) return iconStates.hover
    // return iconStates.default
    return { Icon: iconStates.default, isActive: layout === index, state: isHovered ? 'hover' : isActive ? 'active' : 'default' }
    // return React.createElement(Icon, { state: isHovered ? 'hover' : isActive ? 'active' : 'default' });
  }, [style, index, isHovered, layout])

  return {
    currentIconSrc,
    setIsHovered
  }
}
